var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSql(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96.09 54.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.cls-2{fill:url(#linear-gradient-4);}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:rgba(255,255,255,.44);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 33.41,
    y1: 24.01,
    x2: 44.37,
    y2: 24.01,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 44.16,
    y2: 44.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 51.72,
    y1: 40.24,
    x2: 62.69,
    y2: 40.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 60.71,
    y1: 243.67,
    x2: 71.68,
    y2: 243.67,
    gradientTransform: "translate(-8.99 271.61) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 0.5,
    y: 0.5,
    width: 43.87,
    height: 53.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 20.65,
    x2: 44.37,
    y2: 20.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 27.37,
    x2: 44.37,
    y2: 27.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 13.93,
    x2: 44.37,
    y2: 13.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 7.22,
    x2: 44.37,
    y2: 7.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.41,
    y1: 0.5,
    x2: 33.41,
    y2: 54.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.44,
    y1: 0.5,
    x2: 22.44,
    y2: 27.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 47.52,
    x2: 44.37,
    y2: 47.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 40.8,
    x2: 44.37,
    y2: 40.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 0.5,
    y1: 34.08,
    x2: 44.37,
    y2: 34.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.44,
    y1: 27.37,
    x2: 22.44,
    y2: 54.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.47,
    y1: 0.5,
    x2: 11.47,
    y2: 54.24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 33.41,
    y: 20.65,
    width: 10.97,
    height: 6.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 33.41,
    y: 40.8,
    width: 10.97,
    height: 6.72
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 51.72,
    y: 36.88,
    width: 43.87,
    height: 13.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.72,
    y1: 43.6,
    x2: 95.59,
    y2: 43.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.72,
    y1: 36.88,
    x2: 95.59,
    y2: 36.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.63,
    y1: 36.88,
    x2: 84.63,
    y2: 50.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 73.66,
    y1: 36.88,
    x2: 73.66,
    y2: 50.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 62.69,
    y1: 36.88,
    x2: 62.69,
    y2: 50.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 51.72,
    y: 36.88,
    width: 10.97,
    height: 6.72
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 51.72,
    y: 4.42,
    width: 43.87,
    height: 26.87
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.72,
    y1: 24.57,
    x2: 95.59,
    y2: 24.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.63,
    y1: 31.29,
    x2: 84.63,
    y2: 17.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 73.66,
    y1: 31.29,
    x2: 73.66,
    y2: 17.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 62.69,
    y1: 31.29,
    x2: 62.69,
    y2: 17.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 51.72,
    y: 24.57,
    width: 10.97,
    height: 6.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.72,
    y1: 11.14,
    x2: 95.59,
    y2: 11.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 51.72,
    y1: 17.86,
    x2: 95.59,
    y2: 17.86
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 84.63,
    y1: 17.86,
    x2: 84.63,
    y2: 4.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 73.66,
    y1: 17.86,
    x2: 73.66,
    y2: 4.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 62.69,
    y1: 17.86,
    x2: 62.69,
    y2: 4.42
  }))), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.37,
    y1: 44.16,
    x2: 51.72,
    y2: 40.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.37,
    y1: 24.01,
    x2: 51.47,
    y2: 27.93
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSql);
export default __webpack_public_path__ + "static/media/sql.701dbb75369f5dd7e480ffcf5deec074.svg";
export { ForwardRef as ReactComponent };